export default __webpack_public_path__ + "images/dentistryOneLogo.faf4f9ec5db88ed84c645d276a21554e.svg";